/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForwardNext = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 4h2v16h-2zM4 22.1 16.6 12 4 1.9v20.2zm2-16 7.4 5.9L6 17.9V6.1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgForwardNext as ForwardNext };
